import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CircleIcon from '@mui/icons-material/Circle';

export const Job = (key) => {
  const job = key.job
  const matchMedia = window.matchMedia("(width <= 768px)");
  const [isMobile, setIsMobile] = useState(matchMedia.matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia("(width <= 768px)");
    mediaQueryList.addEventListener('change', (event) => {
      setIsMobile(event.matches);
    });
  }, [isMobile]);

  const fontSize = isMobile ? '2rem' : '3rem';
  const subtitleFont =  isMobile ? '1rem' : '2rem';

  return (
    <Accordion>
        <AccordionSummary
                  expandIcon={<ExpandMoreIcon color='black'/>}
                  aria-controls="panel1a-content"
                  id="panel1a-header">
            <Box width='100%'>
    <Grid xs={12} container alignItems="center">
    <Grid item xs={6}>
        <Typography  variant="h3" fontSize={fontSize} component="div">
        {job.company}
        </Typography>
        <Typography color="text.secondary" variant="h4">
    {job.position}
    </Typography>
    </Grid>
    <Grid item xs={6}>
    <Typography textAlign="right"  variant="h3" fontSize={fontSize} component="div">
        {job.dateRange}
        </Typography>
    </Grid>
    </Grid>
    </Box>
    </AccordionSummary>
    <AccordionDetails>
        <Box marginLeft="1em">
        <Typography  variant="h5" fontSize={subtitleFont} component="div">
        {job.description}
        </Typography> 
        <List dense>

            {job.bullets.map(bullet => {
                return(<ListItem alignItems="flex-start">
                    <CircleIcon fontSize='inherit' style={{padding: '5px'}}></CircleIcon>
                  <Typography variant="h5">{bullet}</Typography>
                </ListItem> )
            })}
               

            </List>
        </Box></AccordionDetails>
    </Accordion>
  )
}

export default Job
